import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ServiceAuthorisationDialogComponent } from 'app/modules/app-components';
import { DataService, HTTPService, HelperService } from 'app/services';
import { EmailReceiptComponent } from 'app/modules/shared/components/email-receipt/email-receipt.component';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss'],
})
export class PaymentReceiptComponent implements OnInit {
  payment: any = {};
  estimate: any = {};
  usd = currency.USD;
  data: any = {};
  url: string = '';
  isPayRix: any = {};
  isPurchase: boolean = false;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private dialogService: DialogService,
    private httpService: HTTPService,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    const data = this.dialogConfig.data;

    if (data && data.data) {
      this.estimate = data.data.estimate;
      this.payment = data.data.payment;
      this.isPayRix = data.data.payrixResponse;
      this.isPurchase = data.data.isPurchase;
    }

    if (this.estimate.estimateId) {
      this.getEstimatesById(this.estimate.estimateId);
    }
  }

  getFile() {
    this.httpService.getDocumentByCustomer(this.payment._id).then(
      (res: any[]) => {
        if (res && res.length && res.length > 0) {
          this.url = res[0].link;
        } else {
          // code for backward compatibility
          this.url = this.payment.receiptLink;
        }
      },
      (err) => {
        //this.helperService.showToaster('error', err);
        return err;
      }
    );
  }

  getEstimatesById(estimateId: string) {
    this.httpService.getEstimateById(estimateId).then(
      (estimate) => {
        this.data = estimate;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  handleEmailReceipt() {
    this.closeDialog();
    setTimeout(() => {
      const ref = this.dialogService.open(EmailReceiptComponent, {
        width: '645px',
        styleClass: 'fixedWidthModal add-dialog',
        showHeader: false,
        data: {
          estimate: this.estimate,
          payment: this.payment,
        },
      });
    }, 500);
  }

  handlePrintReceipt() {
    this.helperService.saveLocalStorage('review-preview', {
      receiptAttach: true,
      reviewAttach: false,

      total: this.data.total ? this.data.total : null,
      company: this.helperService.getCompany(),
    });

    this.getFile();
    if (this.payment.isPdfUploaded) {
      window.open(this.url, '_blank');
    } else {
      window.open(this.payment.previewLink, '_blank');
    }
  }

  startNewPayment() {
    this.closeDialog();

    if (this.isPurchase) {
      this.dataService.sendData(
        this.dataService.typeDialog('add-purchase', 'purchase-order-payment-list', null, null, {
          isNewPayment: true,
          estimate: this.estimate,
        })
      );
    } else {
      const isAnyApproved = this.data.services.some((obj) => obj.serviceStatus === 'approved');
      if (
        this.data.authorizationStatus === 'unapproved' ||
        this.data.vehicleMileage.reading === 0 ||
        this.data.vehicleMileage.reading === 0 ||
        this.data.vehicle.vehicleId.VIN === '' ||
        this.data.vehicle.vehicleId.VIN === undefined
      ) {
        const ref = this.dialogService.open(ServiceAuthorisationDialogComponent, {
          width: '1200px',
          styleClass: 'add-dialog authorization-dialog',
          showHeader: false,
          data: {
            data: {
              openFrom: 'payment',
              estimateId: this.estimate._id,
            },
          },
        });
      } else {
        this.dataService.sendData(
          this.dataService.typeDialog('add-payment', 'payment-list', null, null, {
            estimate: { ...this.estimate, workFlowStatus: this.data.workFlowStatus },
          })
        );
      }
    }
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }
}
